const tables = [
  {
    name: "Date",
  },
  {
    name: "Area",
  },
  {
    name: "Task",
  },
  {
    name: "Expense",
  },
  {
    name: "Status",
  },
  {
    name: "Action",
  },
];

export default tables;
